module.exports = __webpack_public_path__ + "static/media/VEGAN.71312f01.svg";